import * as api from '@owl-nest/api-client/next'

type ListConfig<EXTRA_FIELDS extends string> = {
  accessToken?: string
  extraFields?: readonly EXTRA_FIELDS[]
  limit?: number
  sort?: api.UserProjectSort
  state?: api.UserProjectState
  withToken?: boolean
}

export async function list<EXTRA_FIELDS extends string>(
  id: number,
  { accessToken, extraFields = [], limit, sort, state, withToken = false }: ListConfig<EXTRA_FIELDS> = {},
): Promise<api.HttpResult<api.Pageable<api.ProjectList>>> {
  const getParams: Record<string, string> = {
    extra_fields: extraFields.join(','),
    ...(sort !== undefined && { sort }),
    ...(state !== undefined && { state }),
    limit: limit !== undefined ? String(limit) : '10',
  }

  const response = await api.client('GET /users/:id/projects', {
    getParams,
    token: accessToken,
    urlParams: { id: String(id) },
    withToken,
  })

  return response.next((success) => {
    return success.body
  })
}
